import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import akmApi from "../../../../apis/akmApi";
import { URL_AKM } from "../../../../config";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";

const ListProdi = (props) => {
    const [title, Settitle] = useState(null);
    const [dataProdi, SetdataProdi] = useState([]);
    const [search, Setsearch] = useState(null);
    const [fetching, setFetching] = useState(false);

    const [pages, setpage] = useState(0);
    const [size, setsize] = useState(10);
    const [totalPages, settotalPages] = useState(0);
    const [numberOfElements, setnumberOfElements] = useState(0);
    const [totalElements, settotalElements] = useState(0);

    useEffect(() => {
        Settitle("List Prodi");

        getDatas(size, pages, search);
    }, []);

    const getDatas = async (size, pages, search) => {
        await props.cekCookies();

        setFetching(true);
        const response = await akmApi.get(URL_AKM.LIST_PRODI, {
            params: {
                size: size,
                page: pages,
                nameSearch: search,
            },
        });

        if (response) {
            if (response.data) {
                const responseAPI = response.data.data;
                console.log(responseAPI);

                SetdataProdi(responseAPI.content);

                settotalPages(responseAPI.totalPages);
                setnumberOfElements(responseAPI.numberOfElements);
                settotalElements(responseAPI.totalElements);
            }
            setFetching(false);
        }
    };

    const handleChangePage = async (e, newPage) => {
        setpage(newPage);

        getDatas(size, newPage, search);
        // fetchUniqueListProdi(kodeProdi);
    };

    const handleChangeRowsPerPage = (e) => {
        setpage(0);
        setsize(e.target.value);

        getDatas(e.target.value, pages, search);
        // fetchUniqueListProdi(kodeProdi);
    };

    const handleSearch = async (e) => {
        Setsearch(e.target.value);

        getDatas(size, pages, e.target.value);
        // fetchUniqueListProdi(kodeProdi);
    };

    return (
        <div className="wrapper">
            <Sidebar account={props.account} />

            <div id="content" style={{ paddingBottom: "50px" }}>
                <Navbar title={title} />
                <div className="container-fluid">
                    <div className="row" style={{ paddingBottom: "50px" }}>
                        <div className="col-md-6 offset-md-3">
                            <input type="text" className="form-control d-block" placeholder="Cari Nama Prodi...." onChange={handleSearch} />
                        </div>
                    </div>
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" size="small" style={{ minWidth: 1200 }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">#</TableCell>
                                        <TableCell align="left">Kode Prodi</TableCell>
                                        <TableCell align="left">Perguruan Tinggi</TableCell>
                                        <TableCell align="left">Prodi</TableCell>
                                        <TableCell align="left">Kelompok Prodi</TableCell>
                                        <TableCell align="left">IK</TableCell>
                                        <TableCell align="left">Kuota</TableCell>
                                        <TableCell align="left">Nilai Rataan</TableCell>
                                        <TableCell align="left">MPK Bahasa</TableCell>
                                        <TableCell align="left">MPK IPA</TableCell>
                                        <TableCell align="left">MPK IPS</TableCell>
                                        <TableCell align="left">MPK KURMER</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dataProdi.map((item, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell>{index + 1}.</TableCell>
                                                <TableCell>{item.programStudi.idKodeProdi}</TableCell>
                                                <TableCell>{item.namaPerguruanTinggi}</TableCell>
                                                <TableCell>{item.namaProdi}</TableCell>
                                                <TableCell>{item.programStudi.kelompokProdi}</TableCell>
                                                <TableCell>{item.programStudi.indexKeketatan}</TableCell>
                                                <TableCell>{item.programStudi.dayaTampungBaru}</TableCell>
                                                <TableCell>{item.programStudi.nilaiRataan}</TableCell>
                                                <TableCell>{item.programStudi.mpkpBahasa}</TableCell>
                                                <TableCell>{item.programStudi.mpkpIpa}</TableCell>
                                                <TableCell>{item.programStudi.mpkpIps}</TableCell>
                                                <TableCell>{item.programStudi.mpkpAsesmen}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <TablePagination component="div" count={totalElements} page={pages} onPageChange={handleChangePage} rowsPerPage={size} onRowsPerPageChange={handleChangeRowsPerPage} />
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};
export default connect(mapStateToProps, { cekCookies })(ListProdi);
